import {
  GetAdminNoteListByPatientActionTypes,
  PATIENT_NOTE_LIST_FAIL,
  PATIENT_NOTE_LIST_LOADING,
  PATIENT_NOTE_LIST_SUCCESS,
  GetAdminNoteListByPatientState,
  PATIENT_NOTE_LIST_UPDATE_API_MSG,
  PATIENT_NOTE_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetAdminNoteListByPatientRes } from "./Model";

const initialStateGetPosts: GetAdminNoteListByPatientState = {
  loading: false,
  getAdminNoteListByPatientRes: {} as GetAdminNoteListByPatientRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getAdminNoteListByPatientReducer = (
  state = initialStateGetPosts,
  action: GetAdminNoteListByPatientActionTypes
): GetAdminNoteListByPatientState => {
  switch (action.type) {
    case PATIENT_NOTE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PATIENT_NOTE_LIST_SUCCESS:
      return {
        ...state,
        getAdminNoteListByPatientRes: action.payload,
      };
    case PATIENT_NOTE_LIST_FAIL:
      return {
        ...state,
        getAdminNoteListByPatientRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_NOTE_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getAdminNoteListByPatientRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_NOTE_LIST_UPDATE_API_RES:
      return {
        ...state,
        getAdminNoteListByPatientRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
